<template>
    <div>
        <div v-if="mode === 'view'" class="view-mode" @click="edit()" v-tooltip.top="'Edit Weight'">{{internalValue}}%</div>
        <div v-if="mode !== 'view'" class="edit-mode">
            <input type="number" maxlength="3" v-model="internalValue" v-on-clickaway="leaveEdit">
            <label>%</label>
        </div>
    </div>
</template>

<script>
    import { percentFilter } from '../utility/filters';
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        mixins: [ clickaway ],
        props: {
            value: Number
        },
        methods: {
            edit: function() {
                this.mode = 'edit';
            },
            leaveEdit: function() {
                this.mode = 'view';
                this.$emit('edited', this.internalValue / 100);
            }
        },
        data() {
            return {
                mode: 'view',
                internalValue: this.value * 100
            };
        },
        filters: {
            percent: percentFilter
        }
    }
</script>

<style scoped lang="scss">
    .view-mode {
        &:hover {
            cursor: pointer;
            background-color: rgba(255, 255, 255, 0.2);
        }
    }

    .edit-mode {
        input {
            width: $space-64 - $space-16;
            height: 24px;
            padding: $space-4;
        }
    }
</style>